import React, {Component} from "react";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CancelIcon from '@material-ui/icons/Cancel';
import GetAppIcon from '@material-ui/icons/GetApp';
import LiveTable from "./LiveTable";
import {Dialog, DialogActions, DialogContentText, DialogTitle, FormLabel, Radio, RadioGroup} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

class DeploymentAreaCoverageForm extends Component {

    state = {
        open: false
    }

    handleClickOpen = () => {
        this.setState({
            open: true
        })
    };

    handleClickClose = () => {
        this.setState({
            open: false
        })
    };

    render() {

        const {
            estimatedDeploymentTime,
            dronesConfig,
            deploymentAreaCoverageForm,
            onDeploymentAreaCoverageFormChange,
            deploymentAreaCoverageFormErrors,
            dronesSubscribed,
            project,
            onStartDeployment,
            onAbortExperiment,
            deploymentStatus
        } = this.props;


        return (
            <div style={{padding: '5px'}}>
                <div>Altitude: {project.altitude} m</div>
                <div>Estimated Mission Time: {estimatedDeploymentTime} min</div>
                {parseFloat(estimatedDeploymentTime) > 25 ? <p style={{
                    color: `#f44336`,
                    margin: 0,
                    fontSize: `0.75rem`,
                    marginTop: `8px`,
                    minHeight: `1em`,
                    textAlign: `center`,
                    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                    fontWeight: 400,
                    lineHeight: `1em`,
                    letterSpacing: `0.03333em`,
                }}>The estimated deploymentTime time <br/>exceeds the maximum flight time<br/>(25 min) with a single
                    battery</p> : null}
                <Paper style={{
                    marginTop: '10px',
                    marginBottom: '10px'
                }}>
                    <div style={{padding: '5px'}}>
                        <FormControl style={{width: '200px'}}
                                     error={deploymentAreaCoverageForm.droneCanonicalNames.length === 0 || deploymentAreaCoverageForm.droneCanonicalNames.length != project.numberOfDrones}>
                            <InputLabel htmlFor="type-of-waypointMission">Drones</InputLabel>
                            <Select
                                multiple
                                value={deploymentAreaCoverageForm.droneCanonicalNames}
                                // value={["dji.phantom.4.pro.hawk.1"]}
                                renderValue={selected =>
                                    selected.map(serial => {
                                        const d = dronesConfig.find(function(dr) {
                                            return dr.serial === serial;
                                        });
                                        return d ? d.name : serial;
                                    }).join(', ')
                                }
                                onChange={(evt) => {
                                    onDeploymentAreaCoverageFormChange('droneCanonicalNames', evt);
                                }}
                                inputProps={{
                                    name: 'drones',
                                    id: 'drones',
                                }}
                            >
                                {dronesConfig.map(drone => {
                                    const serial = drone.serial;

                                    const isActive =
                                        dronesSubscribed[serial] &&
                                        dronesSubscribed[serial].active;

                                    return (
                                        <MenuItem
                                            key={serial}
                                            value={serial}
                                            disabled={!isActive}
                                        >
                                            <Checkbox
                                                checked={
                                                    deploymentAreaCoverageForm.droneCanonicalNames.indexOf(serial) > -1
                                                }
                                            />
                                            <ListItemText primary={drone.name} />
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                            {(deploymentAreaCoverageForm.droneCanonicalNames.length === 0 || deploymentAreaCoverageForm.droneCanonicalNames.length != project.numberOfDrones) ?
                                <FormHelperText>number of drones selected should
                                    be {project["numberOfDrones"]}</FormHelperText> : null}
                        </FormControl>
                    </div>
                    <Button style={{margin: '5px'}} variant="outlined" onClick={this.handleClickOpen}>
                        <AddCircleOutlineIcon/>
                        Deployment Configuration
                    </Button>
                    <Dialog open={this.state.open} onClose={this.handleClose}>
                        <div style={{padding: '50px'}}>
                            <DialogTitle id="form-dialog-title">Deployment Configuration</DialogTitle>

                            <div style={{
                                display: "flex", 'align-items': 'center',
                                'justify-content': 'space-between',
                            }}>
                                <div>
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend">Flight Path Mode</FormLabel>
                                        <RadioGroup aria-label="flightPathMode" name="flightPathMode"
                                                    value={deploymentAreaCoverageForm.flightPathMode}
                                                    onChange={(evt) => onDeploymentAreaCoverageFormChange('flightPathMode', evt)}>
                                            <FormControlLabel value='NORMAL' control={<Radio/>} label="Normal"/>
                                            <FormControlLabel value="CURVED" control={<Radio/>}
                                                              label="Curved"/>
                                        </RadioGroup>
                                    </FormControl>
                                </div>


                                <div>
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend">Finished Action</FormLabel>
                                        <RadioGroup aria-label="finishedAction" name="finishedAction"
                                                    value={deploymentAreaCoverageForm.finishedAction}
                                                    onChange={(evt) => onDeploymentAreaCoverageFormChange('finishedAction', evt)}>
                                            <FormControlLabel value='GO_HOME' control={<Radio/>} label="Go Home"/>
                                            <FormControlLabel value="NONE" control={<Radio/>}
                                                              label="None"/>
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                            </div>

                            <div>
                                <TextField style={{width: '100px', padding: '20px'}}
                                           id="standard-name"
                                           label="Speed"
                                           value={deploymentAreaCoverageForm.speed}
                                           onChange={(evt) => onDeploymentAreaCoverageFormChange('speed', evt)}
                                           error={deploymentAreaCoverageFormErrors.speed}
                                           helperText={deploymentAreaCoverageFormErrors.speed}
                                           InputProps={{
                                               endAdornment: <InputAdornment position="end">m/s</InputAdornment>,
                                           }}
                                           margin="normal"
                                />
                            </div>

                            <FormControl component="fieldset">
                                <FormLabel component="legend">Camera Mode</FormLabel>
                                <RadioGroup aria-label="cameraMode" name="finishedAction"
                                            value={deploymentAreaCoverageForm.cameraMode}
                                            onChange={(evt) => onDeploymentAreaCoverageFormChange('cameraMode', evt)}>
                                    <FormControlLabel value='SHOOT_PHOTO_INTERVAL' control={<Radio/>}
                                                      label="Shoot photo interval"/>
                                    <FormControlLabel value="SHOOT_PHOTO_WAYPOINTS" control={<Radio/>}
                                                      label="Shoot photo on waypoints"/>
                                    <FormControlLabel value="LIVE_STREAMING" control={<Radio/>}
                                                      label="Live streaming"/>
                                </RadioGroup>
                            </FormControl>

                            <div style={{
                                display: 'flex', 'align-items': 'center',
                                'justify-content': 'space-between',
                            }}>
                                <div>
                                    <TextField style={{width: '100px', padding: '20px'}}
                                               id="standard-name"
                                               label="Gimbal Pitch"
                                               value={deploymentAreaCoverageForm.gimbalPitch}
                                               onChange={(evt) => onDeploymentAreaCoverageFormChange('gimbalPitch', evt)}
                                               error={deploymentAreaCoverageFormErrors.gimbalPitch}
                                               helperText={deploymentAreaCoverageFormErrors.gimbalPitch}
                                               InputProps={{
                                                   endAdornment: <InputAdornment
                                                       position="end">degrees</InputAdornment>,
                                               }}
                                               margin="normal"
                                    />
                                </div>

                            </div>

                            {deploymentAreaCoverageForm.cameraMode === 'SHOOT_PHOTO_INTERVAL' ?
                                <div>
                                    <div>
                                        <TextField style={{width: '100px', padding: '20px'}}
                                                   id="standard-name"
                                                   label="Max captures per aircraft"
                                                   value={deploymentAreaCoverageForm.shootPhotoIntervalDetails.captureCount}
                                                   onChange={(evt) => onDeploymentAreaCoverageFormChange('shootPhotoIntervalDetails.captureCount', evt)}
                                                   error={deploymentAreaCoverageFormErrors['shootPhotoIntervalDetails.captureCount']}
                                                   helperText={deploymentAreaCoverageFormErrors['shootPhotoIntervalDetails.captureCount']}
                                                   InputProps={{
                                                       endAdornment: <InputAdornment
                                                           position="end">photos</InputAdornment>,
                                                   }}
                                                   margin="normal"
                                        />
                                    </div>
                                    <div>
                                        <TextField style={{width: '100px', padding: '20px'}}
                                                   id="standard-name"
                                                   label="Capture interval"
                                                   value={deploymentAreaCoverageForm.shootPhotoIntervalDetails.timeIntervalInSeconds}
                                                   onChange={(evt) => onDeploymentAreaCoverageFormChange('shootPhotoIntervalDetails.timeIntervalInSeconds', evt)}
                                                   error={deploymentAreaCoverageFormErrors['shootPhotoIntervalDetails.timeIntervalInSeconds']}
                                                   helperText={deploymentAreaCoverageFormErrors['shootPhotoIntervalDetails.timeIntervalInSeconds']}
                                                   InputProps={{
                                                       endAdornment: <InputAdornment
                                                           position="end">seconds</InputAdornment>,
                                                   }}
                                                   margin="normal"
                                        />
                                    </div>
                                </div> : null
                            }

                            <DialogActions>
                                <Button onClick={this.handleClickClose} color="primary">
                                    Ok
                                </Button>
                            </DialogActions>
                        </div>

                    </Dialog>

                </Paper>
                <div>
                    <Paper style={{padding: '5px'}}>
                        <IconButton onClick={onStartDeployment}
                        >
                            {/*disabled={this.props.runDeploymentButtonDisabled}>*/}
                            <span>Run</span>
                            <ArrowForwardIosIcon/>
                        </IconButton>
                    </Paper>
                    {deploymentStatus === 'ONGOING' ?
                        <Paper style={{marginTop: '10px'}}>
                            <IconButton onClick={onAbortExperiment} style={{color: '#7c795d'}}>
                                <span>Abort</span>
                                <CancelIcon/>
                            </IconButton>
                        </Paper> : null}
                </div>
                <Paper style={{
                    marginTop: '10px',
                    marginBottom: '10px'
                }}>
                    <LiveTable dronesSubscribed={this.props.dronesSubscribed}
                               droneStatuses={this.props.droneStatuses}
                               dronesLive={this.props.dronesLive}/>
                </Paper>

            </div>
        )
    }
}

export default DeploymentAreaCoverageForm
